import './utils/consoleSuppression'
import { applyReauthLoginBeforeHydrate } from './utils/crossDomainAuth'
import { reconcileLandingAuthState } from './utils/reconcileLandingAuthState'
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './i18n'
import { initGoogleAnalytics } from './utils/initGoogleAnalytics'
import { initNaverWcs } from './utils/naverWcs'
import { ensureCallDM, ensureCallMtm } from './utils/oneTag'
import reportWebVitals from './reportWebVitals'
import RootProviders from './components/RootProviders'
import App from './App'

applyReauthLoginBeforeHydrate()
reconcileLandingAuthState()
initGoogleAnalytics()
initNaverWcs()
ensureCallMtm()
ensureCallDM()

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

root.render(
  <React.StrictMode>
    <RootProviders>
      <App />
    </RootProviders>
  </React.StrictMode>
)

reportWebVitals()
